module.exports = __webpack_public_path__ + "static/media/report.577b0375.png";